
import DeleteButton from "./DeleteButton";
import ShareEntryDialog from "@/components/ShareEntryDialog";

interface FooterActionsProps {
  entryId: string;
  onDelete: () => void;
}

const FooterActions = ({ entryId, onDelete }: FooterActionsProps) => {
  return (
    <div className="flex gap-2">
      <DeleteButton onDelete={onDelete} />
      <ShareEntryDialog entryId={entryId} />
    </div>
  );
};

export default FooterActions;
